/**
 * Названия сущностей, которые никак не меняются со стороны фронта и выступают исключительно справочниками-словарями
 * @see DictionaryActionsServiceImpl
 */
export enum DICTIONARY_ENTITY_NAME {
  wareCategory = 'wareCategory',
  orderContractType = 'orderContractType',
  distributionCity = 'distributionCity',
  promotionsDictionary = 'promotionsDictionary',
  recommendationsDictionary = 'recommendationsDictionary',
  measurementUnitDictionary = 'measurementUnitDictionary',
  pricePredefinedDictionary = 'pricePredefinedDictionary',
  userPositions = 'userPositions',
}

export const baseMeasurementUnit: MeasurementUnitDTO = {
  id: '796',
  createdAt: Date.now().toString(),
  updatedAt: Date.now().toString(),
  name: 'Штука',
  shortName: 'шт',
  code: '796',
};
